var $ = jQuery.noConflict();
var Modal = (function($) {
  $body = $('body');
  var init = function() {
    // cache body selector
    $body = $('body');
  };

  var toggleModal = function(id) {
    // toggle classes
    if($body.hasClass('body-modal-open')) {
      close(id);
    } else {
      show(id);
    }
  };

  var show = function(id) {
    // add modal open class
    $body.addClass('body-modal-open');

    // set timeout for active class to allow css animation
    setTimeout(function() {
      $(id).addClass('modal-active');
    },25);
  }

  var close = function(id) {
    // remove modal open class
    $body.removeClass('body-modal-open');
    // set timeout for active class to allow css animation
    setTimeout(function() {
      $('.modal').removeClass('modal-active');
    },25);
  };

  return {
    init: init,
    toggleModal: toggleModal,
    show: show,
    close: close
  };
}(jQuery));

// Varinat modal js for slider
var slideIndex = 1;

// used to move slides forward or backwards
function plusDivs(n, class_name) {
  showDivs(slideIndex += n, class_name);
}

// to show the image with given index
// all images of same variant have the same class as image-modal-variant_id
// after the index>count we reset the counter to 1
function showDivs(n, class_name) {
  var i;
  var x = document.getElementsByClassName(class_name);
  if (n > x.length) {slideIndex = 1}
  if (n < 1) {slideIndex = x.length} ;
  for (i = 0; i < x.length; i++) {
    x[i].style.display = 'none';
  }
  x[slideIndex-1].style.display = 'block';

  var y = document.getElementsByClassName('modal-slider');
  for (var j = 0; j < y.length; j++) {
    y[j].style.display = 'block';
  }
}

// toggle filters
function toggleFilters(){
   list = document.getElementById('filter-list')
   list.style.display = list.style.display === 'block' ? 'none' : 'block';
   // switch between plus and minus for filter
   img_src = document.getElementById('filterImg').src
   img_path = img_src.substr(0, img_src.lastIndexOf("/")+1);
   new_img = img_src.includes('plus-white.png') ? 'minus.png' : 'plus-white.png'
   new_img = img_path + new_img;
   document.getElementById('filterImg').src = new_img;
}

// toggle aboutUs
function toggleAboutUs(){
   $(".about-us-description").toggle();
   // switch between plus and minus for filter
   img_src = $(".about-us-snippet .filterImg").attr('src');   
   img_path = img_src.substr(0, img_src.lastIndexOf("/")+1);
   new_img = img_src.includes('plus.png') ? 'minus.png' : 'plus.png'
   new_img = img_path + new_img;   
   $(".about-us-snippet .filterImg").attr('src', new_img);
}

// get the selected checkboxes
function getCheckedValues(){
  var checkedValues = [];
  var inputElements = document.getElementsByClassName('filterCondition');
  for(var i=0; inputElements[i]; ++i){
      if(inputElements[i].checked){
        checkedValues.push(inputElements[i].value);
      }
  }
  return checkedValues;
}

// filter variants based on the selected conditions
// inputs object array containing variant id and condition
// if variant condition matches the selected one, hide the unselected items
function filter_variants(variants){
  checkedValues = getCheckedValues();

  filteredVariants = [];
  var iterator = variants.values()
  for (let variant of iterator) {
    if (!checkedValues.length)
      document.getElementById('row-'+variant['id']).style.display = 'table-row';
    else if (checkedValues.includes(variant['condition'])){
      document.getElementById('row-'+variant['id']).style.display = 'table-row';
    }
    else
      document.getElementById('row-'+variant['id']).style.display = 'none';
  }
}

// when user clicks on swatches for variant options
// show the relevant variant
function filter_swatches(variant_id){
  variants = document.getElementsByClassName('variant-list-items');
  if (variants.length > 0){
   for (var i=0 ; i<variants.length ; i++)
      variants[i].style.display = 'none';
    document.getElementById('row-'+variant_id).style.display = 'table-row';
  }
}

// Custom Function to order by price after custom price data is injected
function sortElementsByPrice(elements, parent, highToLow) {
  // Convert NodeList to an array, if necessary
  if (elements instanceof NodeList) {
    elements = Array.from(elements);
  }

  // Helper function to find the lowest number in a comma-separated string of numbers
  function findLowestNumber(pricesStr) {
    return Math.min(...pricesStr.split(',').map(num => parseFloat(num)));
  }

  // Sort the elements based on the lowest number in the 'data-prices' attribute
  elements.sort((a, b) => {
    const priceA = findLowestNumber(a.getAttribute('data-prices'));
    const priceB = findLowestNumber(b.getAttribute('data-prices'));

    if (highToLow) {
      return priceB - priceA;
    } else {
      return priceA - priceB;
    }
  });

  // Append the sorted elements back to the parent element
  elements.forEach(element => {
    parent.appendChild(element);
  });
}

//Custom JS Functionality
Shopify.queryParams = Shopify.queryParams || {};
if (Object.keys(Shopify.queryParams).length == 0 && location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}

(function() {

  var recurateVariantListInit = function() {

    var slidersInit = function() {

      $('.var-images.slider').on('init', function(event, slick, currentSlide, nextSlide){
        $(this).addClass("slick-loaded");
      });
      $('.var-images-modal.slider').on('init', function(event, slick, currentSlide, nextSlide){
        $(this).addClass("slick-loaded");
      });

      //Variant Image Sliders
      $('.var-images.slider').slick({
        dots: false,
        arrows: true,
        adaptiveHeight: true,
        infinite: true,
        prevArrow: '<div class="hidden slick-prev slick-arrow-svg"><svg width="20" height="20" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5442 1.86047L6.6582 6.97675L1.7722 1.86047" stroke="#333132" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>',
        nextArrow: '<div class="hidden slick-next slick-arrow-svg"><svg width="20" height="20" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5442 1.86047L6.6582 6.97675L1.7722 1.86047" stroke="#333132" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>',
        responsive: [        
          {
            breakpoint: 768,
            settings: {
              dots: true,
              arrows: false
            }
          }      
        ]
      });
      $('.var-images-modal.slider').slick({
        dots: false,
        arrows: true,
        adaptiveHeight: true,
        infinite: true,
        prevArrow: '<div class="slick-prev slick-arrow-svg"><svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="17" cy="17" r="17" fill="white"/>=<path d="M19.1968 10L12.0001 17.1967L19.1968 24.3933" stroke="black" stroke-width="2" stroke-linecap="round"/></svg></div>',
        nextArrow: '<div class="slick-next slick-arrow-svg"><svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="17" cy="17" r="17" transform="rotate(180 17 17)" fill="white"/><path d="M14.8032 24L21.9999 16.8033L14.8032 9.60669" stroke="black" stroke-width="2" stroke-linecap="round"/></svg></div>'      
      });    

      $(".pdp-variant").hover(function() {
        $(this).find(".slick-arrow-svg").removeClass("hidden");
      },
      function() {
        $(this).find(".slick-arrow-svg").addClass("hidden");
      });      
    };  

    //filtering
    var refilter = function() {
      $(".pdp-variant-none").addClass("hidden");    
      $(".pdp-variant").removeClass("filtered-data-size filtered-data-color filtered-data-condition filtered-data-phone");
      if($(".pdp-filter li.active").length > 0) {
        $(".pdp-variant").addClass('hidden');
        var attr;
        $(".pdp-filter").each(function() {
          attr = $(this).data('attr');        
          if($(this).children("li.active").length > 0) {
            $(this).children("li.active").each(function() {
              $(".pdp-variant["+attr+"='" + $(this).data('val') + "']").addClass("filtered-" + attr);
            });
          } else {
            $(".pdp-variant").addClass("filtered-" + attr);
          }
        });         
        $(".pdp-variant.filtered-data-size.filtered-data-color.filtered-data-condition.filtered-data-phone").removeClass("hidden");
        if($(".pdp-variant:visible").length == 0) {
          $(".pdp-variant-none").removeClass("hidden");
        }
      } else {
        $(".pdp-variant").removeClass('hidden');
      }    
      if(window.innerWidth <= 768 && $(".pdp-filtering-inner").hasClass("view")) {
        $('.pdp-filtering h2').click();
        window.scrollTo(0,0);
      }
      resort($('#pdp-sort').val()=="price-asc");
    }
    $('.pdp-filter li').click(function() {
      $(this).toggleClass("active");
      refilter();
    });

    $('.pdp-filter li').keypress(function(e) {
      if(e.which == 13) {
        $(this).toggleClass("active");
        refilter();
      }     
    });
    $('.variant-select.selected').click();
    if(window.innerWidth <= 768) {
      $('.pdp-filtering h2').click(function() {      
        $(".pdp-filtering .collapse").toggleClass("rotate");
        $(".pdp-filtering-inner").toggleClass("view");
      });
    }

    //sorting
    var resort = function(asc) {    
      $('.var-images.slider.slick-initialized').removeClass("slick-loaded");
      $('.var-images.slider.slick-initialized').slick('unslick');    
      $('.var-images-modal.slider.slick-initialized').removeClass("slick-loaded");
      $('.var-images-modal.slider.slick-initialized').slick('unslick');    
      var divList = $(".pdp-variant");    
      divList.sort(function(a, b){
          return asc?$(a).data("price")-$(b).data("price"):$(b).data("price")-$(a).data("price")
      });
      $(".pdp-variant").remove();
      $(".pdp-variants").append(divList);

      //handle intl/country filter
      $(".pdp-variant-none").addClass("hidden");
      pdpCountryFilter(browsingCountry,$(".product-wrap"));      
      
      slidersInit();    
      if(window.innerWidth <= 768 && $(".pdp-filtering-inner").hasClass("view")) {
        $('.pdp-filtering h2').click();
        window.scrollTo(0,0);
      }
    }
    $('#pdp-sort').on("change", function() {
      resort($(this).val()=="price-asc");
    });

    //ok, go ahead and display things in the right initial sort order for the right (or any) country
    var browsingCountry = null;    
    if(recurateOptions.intl) {
      $.ajax({
        dataType: "json",
        url: "/browsing_context_suggestions.json",        
        success: function(json) {
          browsingCountry = json.detected_values.country.handle;               
          if( (typeof Shopify.queryParams !== "undefined") && (typeof Shopify.queryParams.country !== "undefined")) {
            browsingCountry = (Shopify.queryParams.country == "null") ? null : Shopify.queryParams.country;
          }
          resort(true);
          updateCountryElements();

          //go through all the filters and make sure they should be there after we've filtered variants for the country
          $(".pdp-filter:visible").each(function() {
            var attr = $(this).data('attr');    
            $(this).children("li").each(function() {          
              if($(".pdp-variant["+attr+"='" + $(this).data('val') + "']:visible").length == 0) {
                $(this).addClass("hidden");
              }
            });
            if($(this).closest(".pdp-filtering-group").find(".pdp-filter li:visible").length == 0) {
              $(this).closest(".pdp-filtering-group").addClass("hidden");
            }
            console.log(attr);
          });
        },
        error: function(json) {          
          resort(true);
        }
      });      
    } else {      
      resort(true);
    }
    
    //click on any actively selected variant
    $('.variant-select.selected').click();

  };  

  //disable adding items outside of country
  function updateCountryElements() {
    const addToCartBtns = document.querySelectorAll('.intl-mismatch .var-actions button');
  
    if (addToCartBtns) {
      addToCartBtns.forEach((btn) => {
        btn.disabled = true;
    
        //disable modal add-to-cart btn
        const variantId = btn.dataset.id;
        const variantBtn = document.querySelector(`[data-id="${variantId}"]`);
        if (variantBtn) {
          variantBtn.disabled = true;
        }
      });
    }
  };

  //function to handle logic on used collections
  var recurateCollectionInit = function() {

    var browsingCountry = null;
    if(recurateOptions.intl) {
      $.ajax({
        dataType: "json",
        url: "/browsing_context_suggestions.json",        
        success: function(json) {
          browsingCountry = json.detected_values.country.handle;
          if( (typeof Shopify.queryParams !== "undefined") && (typeof Shopify.queryParams.country !== "undefined")) {
            browsingCountry = (Shopify.queryParams.country == "null") ? null : Shopify.queryParams.country;
          }
          collectionCountryFilter(browsingCountry,$("body"));  
          updateCountryElements();        
        },
        error: function(json) {          
          $(".intl-pending").removeClass("intl-pending");  
        }
      });      
    } else {
      $(".intl-pending").removeClass("intl-pending");
    }

    $("body").on("click","#recurate-collection-country-filter",function(e) {
      e.preventDefault();
      collectionCountryFilter(browsingCountry,$("body"));      
    });
  };

  //filter the collection list by the appropriate browsing country
  var collectionCountryFilter = function(country, parent) {

    //no country in play, just proceed
    if(!country) {
      $(".intl-pending").removeClass("intl-pending");
      return true;
    }    

    //go through each variant on the page and make sure it, or the default, matches the current country    
    $(".recurate-collection-item",parent).each(function() {         
      var priceMin = 0,priceMax = 0,variantsAvailable = 0
      ,countryList = ((typeof $(this).data('countries') !== "undefined") && $(this).data('countries') != "") ? $(this).data('countries').toString().toUpperCase().split(',') : [recurateOptions.defaultCountry]
      ,availability = ((typeof $(this).attr('data-availability') !== "undefined") && $(this).attr('data-availability') != "") ? $(this).attr('data-availability').toString().toUpperCase().split(',') : []
      ,prices = ((typeof $(this).data('prices') !== "undefined") && $(this).data('prices') != "") ? $(this).data('prices').toString().toUpperCase().split(',') : [];
      if(countryList.indexOf(country) < 0) {
        $(this).addClass("intl-mismatch");
      } else {                  
        for(var pa in availability) {
          if(countryList[pa] == country) {
            if(availability[pa] == "TRUE") {
              variantsAvailable++;
            }
            if(priceMin == 0 || parseInt(prices[pa]) < priceMin) {
              priceMin = prices[pa];
            }      
            if(priceMax == 0 || parseInt(prices[pa]) > priceMax) {
              priceMax = prices[pa];
            }
          }          
        }   
        if($(this).attr('id') == "object-grid-item-florence-dress") {
          console.log($(this).attr('id'),prices,countryList,country,variantsAvailable,priceMin,priceMax);
        }
        
        //reset the display of avilable variants min/max pricing
        if(variantsAvailable == 0) {
          $(".object-pricing",$(this)).remove();
        }
        else if(priceMin == priceMax) {
          $(".object-pricing",$(this)).text(recurateOptions.moneyFormat.replace("{{amount}}",(priceMin/100).toFixed(2)));
        } else {
          $(".object-pricing",$(this)).text(recurateOptions.moneyFormat.replace("{{amount}}",(priceMin/100).toFixed(2)) + " - " + recurateOptions.moneyFormat.replace("{{amount}}",(priceMax/100).toFixed(2)));
        }
        $(".object-variants-available .cnt",$(this)).text(variantsAvailable);
        if(variantsAvailable == 1) {
          $(".object-variants-available .plural",$(this)).hide();
        } else {
          $(".object-variants-available .plural",$(this)).show();
        }
      }
    });   
    
    $(".recurate-collection-item.intl-pending").removeClass("intl-pending");

    // logic to handle sorting the items by price using the custom pricing set above
    if(location.href.includes('price-descending')){
      sortElementsByPrice($('.object-grid-item').get(),$('.object-grid')[0],true);
    } else if(location.href.includes('price-ascending')){
      sortElementsByPrice($('.object-grid-item').get(),$('.object-grid')[0],false);
    } 
  };

  //filter the variant list by the appropriate browsing country
  var pdpCountryFilter = function(country, parent) {
    
    //no country in play, just proceed
    if(!country) {
      $(".intl-pending").removeClass("intl-pending");
      return true;
    }    

    //go through each variant on the page and make sure it, or the default, matches the current country
    var priceMin = 0,priceMax = 0,variantsAvailable = 0;
    $(".pdp-variant",parent).each(function() {
      var variantCountry = ((typeof $(this).data('country') !== "undefined") && $(this).data('country') != "") ? $(this).data('country') : recurateOptions.defaultCountry;        
      if($.trim(country).toUpperCase() != $.trim(variantCountry).toUpperCase()) {
        $(this).addClass("intl-mismatch");
      } else {          
        variantsAvailable++;    
        if(priceMin == 0 || parseInt($(this).data('price')) < priceMin) {
          priceMin = $(this).data('price');
        }      
        if(priceMax == 0 || parseInt($(this).data('price')) > priceMax) {
          priceMax = $(this).data('price');
        }
      }
    });    

    //reset the display of avilable variants min/max pricing
    if(variantsAvailable == 0) {
      $(".object-pricing",parent).remove();
      $(".pdp-variant-none").removeClass("hidden");      
      $(".pdp-filters").addClass("hidden");
    }
    else if(priceMin == priceMax) {
      $(".object-pricing-min",parent).text(recurateOptions.moneyFormat.replace("{{amount}}",(priceMin/100).toFixed(2)));
    } else {
      $(".object-pricing-min",parent).text(recurateOptions.moneyFormat.replace("{{amount}}",(priceMin/100).toFixed(2)));// + " - " + recurateOptions.moneyFormat.replace("{{amount}}",(priceMax/100).toFixed(2)));
    }
    $(".object-variants-available .cnt",parent).text(variantsAvailable);
    /*if(variantsAvailable == 1) {
      $(".recurate-product-variants-available .plural",parent).hide();
    } else {
      $(".recurate-product-variants-available .plural",parent).show();
    }*/

    $(".intl-pending").removeClass("intl-pending");      
  };

  //do we see the Recurate code? If so, init the PDP
  if($(".pdp-variants").length > 0) {    
    recurateVariantListInit();
  } else if($(".recurate-collection-item").length > 0) {
    recurateCollectionInit();
  }  

})();
